import axios from 'axios';
import { API_URL, API_URL_PDF } from '../config/constants';
import BaseService from './baseService';
const rota = 'config-geral';
const service = new BaseService(rota);

const getList = async (body, skip, limit) => {
    const res = await service.getList(body, skip, limit);
    return res;
}

const getById = async (id) => {
    const res = await service.getById(id);
    return res;
}

const reorder = async (body) => {
    const res = await service.reorder(body);
    return res;
}

const upsert = async (body, id) => {
    const res = await service.upsert(body, id);
    return res;
}


const get = async (rotaAdd) => {
    const res = await service.get(`${rota}/${rotaAdd}`);
    return res;
}

const getUnique = async () => {
    const res = await service.get(`${rota}/unique`);
    return res;
}

export default { getList, getById, upsert, reorder, get, getUnique };
